import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79388d8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("保存")


  import {
    useUserEditDialog,
    FormInstance,
  } from '@/logic/users/UserEditDialogLogic'

  interface Props {
    modelValue: boolean;
    user: {id: number, name: string, role: string};
  }
  interface Emits {
    (e: 'submit'): void;
    (e: 'update:model-value', value: boolean): void;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean, required: true },
    user: { type: Object, required: true }
  },
  emits: ["submit", "update:model-value"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'submit'): void;
    (e: 'update:model-value', value: boolean): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: boolean;
    user: {id: number, name: string, role: string};
  }
  

  

  const {
    formRef,
    form,
    rules,
    handleSubmit: _handleSubmit,
    loading,
  } = useUserEditDialog();

  const handleSubmit = (formEl: FormInstance | undefined) => {
    if (!formEl) return

    formEl.validate(async (valid) => {
      if (valid) {
        if (await _handleSubmit()) {
          emit('submit');
        }
      }
    });
  }

  const handleOpen = () => {
    form.id = props.user.id;
    form.values.name = props.user.name;
    form.values.role = props.user.role

    emit('update:model-value', true);
  };

  const handleClose = () => {
    form.id = null;
    form.values = {
      name: '',
      password: '',
      role: 'member',
    };

    emit('update:model-value', false);
  }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.modelValue,
    onOpen: handleOpen,
    onClose: handleClose,
    title: "編集",
    width: "30%",
    "destroy-on-close": ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSubmit(_unref(formRef))))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_el_form, {
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            _isRef(formRef) && (formRef.value = _value)
          },
          model: _unref(form).values,
          rules: _unref(rules),
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "パスワード",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  modelValue: _unref(form).values.password,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).values.password) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "名前",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(form).values.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).values.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "権限",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(form).values.role,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).values.role) = $event)),
                  class: "m-2",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      key: "member",
                      label: "一般",
                      value: "member"
                    }),
                    _createVNode(_component_el_option, {
                      key: "manager",
                      label: "管理者",
                      value: "manager"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ], 512), [
        [_directive_loading, _unref(loading)]
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})